import type { ImAccount } from '@fruitful/types';
import * as React from 'react';
import { Animations, Notice, View } from 'smoothie';

/** True when the funded account is the Roth leg of a backdoor pair (`backdoorRothRole === 'ROTH'`). */
export const shouldWarnBackdoorRothIctDeposit = (
    account: ImAccount | null | undefined,
): boolean => account?.backdoorRothRole === 'ROTH';

export const BackdoorRothIctDepositWarningNotice = () => {
    return (
        <View {...Animations.FadeInFromAbove}>
            <Notice
                variant="warning"
                title="Before you transfer"
                description="This account is part of a backdoor Roth conversion strategy. Direct contributions may conflict with this strategy. Consult your Guide for questions."
            />
        </View>
    );
};
